// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "root-2wwFF";
var _4 = "header-39pls";
var _5 = "text-3RU8q";
var _6 = "content-3pjrT";
var _7 = "footer-3fZIG";
var _8 = "segments-3Pqgc";
var _9 = "info-1Iyx1";
var _a = "toggle-2K3cV";
var _b = "disclaimer-2Kl3H";
var _c = "content_disclaimer-3mVaN";
export { _1 as "__esModule", _2 as "mobile", _3 as "root", _4 as "header", _5 as "text", _6 as "content", _7 as "footer", _8 as "segments", _9 as "info", _a as "toggle", _b as "disclaimer", _c as "content_disclaimer" }
export default { "__esModule": _1, "mobile": _2, "root": _3, "header": _4, "text": _5, "content": _6, "footer": _7, "segments": _8, "info": _9, "toggle": _a, "disclaimer": _b, "content_disclaimer": _c }
